import axios from 'axios';
import storage from '@/helpers/storage';
import okta from '@/helpers/okta';
import Vue from 'vue';
const orgUrl = window.location.href.indexOf("identityservices.mycargill.com") > -1 ? process.env.CUSTOM_ORG_URL : process.env.ORG_URL;
let brandDetails = "";
let environment = process.env.NODE_ENV;
if (environment === 'production') {
  brandDetails = require('./brand-details.json');
} else if (environment === 'stage') {
  brandDetails = require('./brand-details-stage.json');
} else {
  brandDetails = require('./brand-details-dev.json');
}
var brand = brandDetails.data.filter(i => i.applicationUrls.indexOf(document.location.host) > -1)
var apiEndpoint = brand.length ? brand[0].apiEndpoint : '1c'
// import storage from '@/helpers/storage'; // uncomment later
// Add a request interceptor
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  // config.headers.token = storage.get('cf-user'); // uncomment later
  // config.headers['Cache-Control'] = 'no-cache';
  config.timeout = 100000
  config.maxContentLength = 52428890
  if (config.url.indexOf('/auth/') > -1) {
    config.url = config.url.replace('onecargill/portal/v1/auth', '1c/onecargill-services-mycargill/v1') // to accomodate newly changed api url
    config.url = config.url.replace('1c', apiEndpoint) // to modify api enpoint based on the brand
    config.headers.Authorization = 'Bearer ' + Vue.prototype.$auth.getAccessToken()
  } else {
    // console.log(config.url)
    config.url = config.url.replace('onecargill/portal/v1', '1c/onecargill-services-mycargill/v1/recovery') // to accomodate newly changed api url
    config.url = config.url.replace('1c', apiEndpoint) // to modify api enpoint based on the brand
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  // console.log('URL:' + response.config.url)
  return response;
}, function (error) {
  console.log('URL:' + error.config.url)
  if (error.config.url.indexOf('/auth/') > -1 && error.response === undefined) {
    // 302 code
    console.log('loggin out cos error.response undefined')
    okta.oktaSignOut();
    storage.clearAll();
  } else {
    // Do something with response error
    console.log(error.config)
    if (error.message && error.message.toLowerCase().indexOf('timeout') > -1) {
      window.alert('Timeout error! Please try again later.')
    }
    return Promise.reject(error);
  }
});

export default {
  getCurrentState(data) {
    return axios({
      method: 'post',
      url: orgUrl + "api/v1/authn",
      data: data,
      headers: {'Content-Type': 'application/json'}
    })
  },
  getAppByName(url) {
    return axios({
      method: 'get',
      url: url,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  getCurrentSession() {
    return axios({
      method: 'get',
      url: orgUrl + "api/v1/sessions/me",
      data: null,
      headers: {'Content-Type': 'application/json'},
      withCredentials: true
    })
  },
  getPasswordPolicy(url, actToken) {
    if (actToken) {
      return axios({
        method: 'get',
        url: `${url}`,
        data: null,
        headers: {'RecoveryToken': actToken}
      })
    } else {
      return axios({
        method: 'get',
        url: `${url}`,
        data: null
      })
    }
  },
  getFactorByUserId(url, actToken) {
    if (actToken) {
      return axios({
        method: 'get',
        url: `${url}`,
        data: null,
        headers: {'Content-Type': 'application/json', 'RecoveryToken': actToken}
      })
    } else {
      return axios({
        method: 'get',
        url: `${url}`,
        data: null,
        headers: {'Content-Type': 'application/json'}
      })
    }
  },
  login(url, data) {
    return axios({
      method: 'post',
      url: `${url}`,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      },
      data: data,
      params: data
    })
  },
  createUser(url, data) {
    return axios.post(url, data)
  },
  setUserAccount(url, data, actToken) {
    if (actToken) {
      return axios({method: 'post', url: url, data: data, 'headers': {'RecoveryToken': actToken}})
    } else {
      return axios({method: 'post', url: url, data: data})
    }
  },
  sendCode(url, data, actToken) {
    if (actToken) {
      return axios({method: 'post', url: url, data: data, 'headers': {'RecoveryToken': actToken}})
    } else {
      return axios({method: 'post', url: url, data: data})
    }
  },
  resetPasswordByEmailByUser(url, data) {
    return axios.post(url, data)
  },
  resetPasswordBySMSByUser(url, data) {
    return axios.post(url, data)
  },
  resetPasswordByEmailByAdmin(url, data) {
    return axios.post(url, data)
  },
  verifyPasscodeOnFactorSetting(url, data, actToken) {
    if (actToken) {
      return axios({method: 'post', url: url, data: data, 'headers': {'RecoveryToken': actToken}})
    } else {
      return axios({method: 'post', url: url, data: data})
    }
  },
  getUserIdByToken(url, data) {
    return axios.post(url, data)
  },
  verifySecurityAnswer(url, data) {
    return axios.post(url, data)
  },
  resetPassword(url, data) {
    return axios.post(url, data)
  },
  verifyOTPWithStateToken(url, data) {
    return axios.post(url, data)
  },
  changePassword(url, data) {
    return axios.post(url, data)
  },
  getActiveAppNames(url, actToken) {
    if (actToken) {
      return axios({
        method: 'get',
        url: `${url}`,
        data: null,
        headers: {'Content-Type': 'application/json', 'RecoveryToken': actToken}
      })
    } else {
      return axios({
        method: 'get',
        url: `${url}`,
        data: null,
        headers: {'Content-Type': 'application/json'}
      })
    }
  },
  getUserIdByEmail(url, actToken) {
    if (actToken) {
      return axios({
        method: 'get',
        url: `${url}`,
        data: null,
        headers: {'Content-Type': 'application/json', 'RecoveryToken': actToken}
      })
    } else {
      return axios({
        method: 'get',
        url: `${url}`,
        data: null,
        headers: {'Content-Type': 'application/json'}
      })
    }
  },
  deleteSMSFactor(url, actToken) {
    if (actToken) {
      return axios({
        method: 'delete',
        url: url,
        data: null,
        headers: {'Content-Type': 'application/json', 'RecoveryToken': actToken}
      })
    } else {
      return axios({
        method: 'delete',
        url: url,
        data: null,
        headers: {'Content-Type': 'application/json'}
      })
    }
  },
  getUserRoleById (url) {
    return axios({
      method: 'get',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  getGroupsByAppId (url) {
    return axios({
      method: 'get',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  getGroupByName (url) {
    return axios({
      method: 'get',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  getGroupsByUserId (url, actToken) {
    if (actToken) {
      return axios({
        method: 'get',
        url: `${url}`,
        data: null,
        headers: {'Content-Type': 'application/json', 'RecoveryToken': actToken}
      })
    } else {
      return axios({
        method: 'get',
        url: `${url}`,
        data: null,
        headers: {'Content-Type': 'application/json'}
      })
    }
  },
  getUserDetailsOfApp (url) {
    return axios({
      method: 'get',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  getUserDetailsOfGroup (url) {
    url = url.indexOf('~~~') > -1 ? url.split('~~~')[0] + '/' + (url.split('~~~')[1].split('/').slice(1)).join('/') : url
    return axios({
      method: 'get',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  getUserDetailsOfSearch (url) {
    return axios({
      method: 'get',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  assignUserToGroup (url) {
    url = url.indexOf('~~~') > -1 ? url.split('~~~')[0] + '/' + (url.split('~~~')[1].split('/').slice(1)).join('/') : url
    return axios({
      method: 'patch',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  unassignUserFromGroup (url) {
    url = url.indexOf('~~~') > -1 ? url.split('~~~')[0] + '/' + (url.split('~~~')[1].split('/').slice(1)).join('/') : url
    return axios({
      method: 'delete',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  getGroupStats (url) {
    url = url.indexOf('~~~') > -1 ? url.split('~~~')[0] : url
    return axios({
      method: 'get',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  getClientIds (url, email) {
    return axios({
      method: 'get',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json', 'user': `${email}`}
    })
  },
  getLogs (url) {
    return axios({
      method: 'get',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  getListOfSuperUserApps (url) {
    return axios({
      method: 'get',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  getListOfAdminConfig (url) {
    return axios({
      method: 'get',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  getListOfSecurityQuestionsByLanguage (url, actToken) {
    if (actToken) {
      return axios({
        method: 'get',
        url: `${url}`,
        data: null,
        headers: {'Content-Type': 'application/json', 'RecoveryToken': actToken}
      })
    } else {
      return axios({
        method: 'get',
        url: `${url}`,
        data: null,
        headers: {'Content-Type': 'application/json'}
      })
    }
  },
  sendReInvite (url) {
    return axios.post(url, {})
  },
  addToAdminConfigDB(url, data) {
    return axios.post(url, data)
  },
  deleteAdminConfig(url, data) {
    return axios({
      method: 'delete',
      url: url,
      data: data,
      headers: {'Content-Type': 'application/json'}
    })
  },

  axiosPost(url, data) {
    return axios.post(url, data, {
      headers: {token: ''}
    })
  },
  getAllowedApps (url) {
    return axios({
      method: 'get',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  unlockUser (url) {
    return axios({
      method: 'get',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  updateAllowedApps(url, data) {
    return axios.post(url, data)
  },
  downloadReport(url) {
    return axios({
      method: 'get',
      url: `${url}`,
      responseType: 'arraybuffer'
    })
  },
  validateUserDetails(url, data, actToken) {
    return axios({method: 'post', url: url, data: data, 'headers': {'RecoveryToken': actToken}})
  },
  getDxpDetails (url) {
    return axios({
      method: 'get',
      url: `${url}`,
      data: null,
      headers: {'Content-Type': 'application/json'}
    })
  },
  sendDxpReInvite (url) {
    return axios.post(url, {})
  },
  sendSelfRegistration (url, data, actToken) {
    return axios({method: 'post', url: url, data: data, 'headers': {'RecoveryToken': actToken}});
  },
  updateName(url, data) {
    return axios.post(url, data)
  },
  sendMessageToDatadog(url, data) {
    return axios.post(url, data)
  },
  getAdminGroup(url) {
    return axios.get(url)
  },
  getAppGroupConfigData(url, data) {
    return axios.patch(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/idm-api.js